<template>
	<div>
		<a-form :model="formState" name="basic" style="width: 100%" ref="formRef" layout="vertical" autocomplete="off">
			<div class="primary-title">
				配储方案
				<div class="primary-title-line"></div>
			</div>
			<a-row :gutter="12">
				<a-col :span="24">
					<a-form-item
						label="选择最终容量"
						name="jobId"
						:rules="[
							{
								required: true,
								message: '请输入选择最终容量',
							},
						]"
					>
						<a-select
							placeholder="请选择容量"
							size="large"
							v-model:value="formState.jobId"
							:disabled="props.inputDisabled"
							:getPopupContainer="triggerNode => triggerNode.parentNode"
						>
							<a-select-option v-for="(item, index) in capcityList" :key="index" :value="item.id">
								{{ item.text }}
							</a-select-option>
						</a-select>
						<a-select
							placeholder="请选择策略"
							size="large"
							v-model:value="formState.strategyType"
							style="margin-top: 4px"
							:disabled="props.inputDisabled"
							:getPopupContainer="triggerNode => triggerNode.parentNode"
						>
							<a-select-option :value="1">固定策略</a-select-option>
							<a-select-option :value="2">智能策略</a-select-option>
						</a-select>
					</a-form-item>
				</a-col>
			</a-row>
			<div class="primary-title">
				成本参数
				<div class="primary-title-line"></div>
			</div>
			<a-row :gutter="12">
				<a-col :span="24">
					<a-form-item
						label="储能单价"
						name="unitPrice"
						:rules="[
							{
								required: true,
								message: '请输入选择最终容量',
							},
						]"
						help="包含设备材料费、建安工程费等所有费用"
					>
						<a-input
							placeholder="请输入储能单价"
							v-model:value="formState.unitPrice"
							suffix="元/Wh"
							size="large"
							:disabled="props.inputDisabled"
							@input="inputCondition('unitPrice', 99.99)"
							@blur="mouseBlur('unitPrice')"
						></a-input>
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item
						label="年运营成本"
						name="operationCost"
						:rules="[
							{
								required: true,
								message: '请输入选择最终容量',
							},
						]"
					>
						<a-input
							placeholder="请输入"
							prefix="建设成本的"
							suffix="%"
							v-model:value="formState.operationCost"
							:disabled="props.inputDisabled"
							size="large"
							@input="inputCondition('operationCost', 100)"
							@blur="mouseBlur('operationCost')"
						></a-input>
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item
						label="储能寿命"
						name="lifeYear"
						:rules="[
							{
								required: true,
								message: '请输入储能寿命',
							},
						]"
					>
						<a-input
							placeholder="请输入"
							suffix="年"
							v-model:value="formState.lifeYear"
							size="large"
							@change="makeLifeList"
							:disabled="props.inputDisabled"
							@input="integerCondition('lifeYear', 1, 50)"
						></a-input>
					</a-form-item>
				</a-col>
				<a-col :span="12">
					<a-form-item
						label="年运行天数"
						name="yearRunDays"
						:rules="[
							{
								required: true,
								message: '请输入',
							},
						]"
					>
						<a-input
							placeholder="请输入"
							suffix="天"
							v-model:value="formState.yearRunDays"
							size="large"
							:disabled="props.inputDisabled"
							@input="integerCondition('lifeYear', 1, 366)"
						></a-input>
					</a-form-item>
				</a-col>
				<a-col :span="24">
					<a-form-item
						label="年衰减率"
						name="annualDecayRate"
						:rules="[
							{
								required: true,
								message: '请输入每年老化损失容量的百分比',
							},
						]"
						help="请输入每年老化损失容量的百分比"
					>
						<a-input
							placeholder="请输入"
							suffix="%"
							v-model:value="formState.annualDecayRate"
							size="large"
							:disabled="props.inputDisabled"
							@input="inputCondition('annualDecayRate', 100)"
							@blur="mouseBlur('annualDecayRate')"
						></a-input>
					</a-form-item>
				</a-col>
			</a-row>
			<div class="primary-title">
				分成方案
				<div class="primary-title-line"></div>
			</div>
			<div class="scheme">
				<div class="row">
					<div class="font">前</div>
					<a-select
						placeholder="请选择"
						size="large"
						v-model:value="formState.yearThreshold"
						style="width: 89px"
						:disabled="props.inputDisabled"
						:getPopupContainer="triggerNode => triggerNode.parentNode"
					>
						<a-select-option v-for="(item, index) in yearList" :key="index" :value="item">
							{{ item }}
						</a-select-option>
					</a-select>
					<div class="font">年，投资方获得</div>
					<a-input
						suffix="%"
						style="width: 89px; font-size: 14px"
						size="large"
						placeholder="请输入"
						v-model:value="formState.earlyPercent"
						:disabled="props.inputDisabled"
						@input="inputCondition('earlyPercent', 100)"
						@blur="mouseBlur('earlyPercent')"
					></a-input>
				</div>
				<div class="row">
					<div class="font">{{ formState.yearThreshold }} 年后，投资方获得</div>
					<a-input
						suffix="%"
						style="width: 101px; font-size: 14px"
						size="large"
						placeholder="请输入"
						v-model:value="formState.laterPercent"
						:disabled="props.inputDisabled"
						@input="inputCondition('laterPercent', 100)"
						@blur="mouseBlur('laterPercent')"
					></a-input>
				</div>
			</div>
			<div class="primary-title mt24">
				税费参数
				<a-switch v-model:checked="commission" style="margin: 0 8px 0 18px" :disabled="props.inputDisabled" @change="taxChange" />
				<span class="top-tips">税费参数{{ commission ? "" : "不" }}计入经济分析</span>
				<div class="primary-title-line"></div>
			</div>
			<a-row v-if="commission">
				<a-form-item
					label="进项税：建设期设备材料费税率"
					name="buildInputTax"
					:rules="[
						{
							required: true,
							message: '请输入',
						},
					]"
				>
					<a-input
						placeholder="请输入进项税"
						v-model:value="formState.buildInputTax"
						suffix="%"
						size="large"
						:disabled="props.inputDisabled"
						@input="taxCondition('buildInputTax')"
						@blur="mouseBlur('buildInputTax')"
					></a-input>
				</a-form-item>
				<a-form-item
					label="进项税：经营期运营费税率"
					name="operationInputTax"
					:rules="[
						{
							required: true,
							message: '请输入',
						},
					]"
				>
					<a-input
						placeholder="请输入进项税"
						v-model:value="formState.operationInputTax"
						suffix="%"
						size="large"
						:disabled="props.inputDisabled"
						@input="taxCondition('operationInputTax')"
						@blur="mouseBlur('operationInputTax')"
					></a-input>
				</a-form-item>
				<a-form-item
					label="销项税：现金流入税率"
					name="outputTax"
					:rules="[
						{
							required: true,
							message: '请输入',
						},
					]"
				>
					<a-input
						placeholder="请输入销项税"
						v-model:value="formState.outputTax"
						suffix="%"
						:disabled="props.inputDisabled"
						size="large"
						@input="taxCondition('outputTax')"
						@blur="mouseBlur('outputTax')"
					></a-input>
				</a-form-item>
				<a-form-item
					label="设备折旧年限"
					name="yearDepreciation"
					:rules="[
						{
							required: true,
							message: '请输入',
						},
					]"
				>
					<a-input
						placeholder="请输入设备折旧年限"
						v-model:value="formState.yearDepreciation"
						suffix="年"
						:disabled="props.inputDisabled"
						@input="yearDepreciationCondition"
						size="large"
					></a-input>
				</a-form-item>
				<a-form-item
					label="所得税税率"
					name="incomeTax"
					:rules="[
						{
							required: true,
							message: '请输入',
						},
					]"
				>
					<a-input
						placeholder="请输入所得税税率"
						v-model:value="formState.incomeTax"
						suffix="%"
						:disabled="props.inputDisabled"
						@input="taxCondition('incomeTax')"
						@blur="mouseBlur('incomeTax')"
						size="large"
					></a-input>
				</a-form-item>
			</a-row>
		</a-form>

		<a-button type="primary" class="bottom-btn" style="width: 100%" @click="startEconomicAnalysis" :disabled="props.inputDisabled">
			<span>
				{{ props.economicId ? `重新开始经济分析` : "开始经济分析" }}
			</span>
		</a-button>
	</div>
</template>

<script setup>
import {onMounted, onBeforeUnmount, reactive, ref, watch, defineProps, defineEmits} from "vue";

// 引入vuex
import {useStore} from "vuex";
const store = useStore();

// 引入api
import {getAnalysisCapacityList, startEconomic} from "@/api/economic.js";
import {getRecommend} from "@/api/scheme.js";

const props = defineProps({
	loadId: {
		type: String,
		default: () => {
			return "";
		},
	},
	economicId: {
		type: String,
		default: () => {
			return "";
		},
	},
	economicAnalysisVOData: {
		type: Object,
		default: () => {
			return null;
		},
	},
	inputDisabled: {
		type: Boolean,
		default: () => {
			return false;
		},
	},
});

const emit = defineEmits(["startAnalysis"]);

// 容量列表
const capcityList = ref([]);
// 年份列表
const yearList = ref([]);
// 表单数据
const formState = reactive({
	jobId: undefined,
	strategyType: 1,
	unitPrice: 1.5,
	operationCost: 2,
	lifeYear: 10,
	yearRunDays: 330,
	annualDecayRate: 2,
	yearThreshold: 5,
	earlyPercent: 80,
	laterPercent: 80,
	buildInputTax: 13,
	operationInputTax: 6,
	outputTax: 13,
	yearDepreciation: 5,
	incomeTax: 25,
});
const formRef = ref();

// 税费开关
const commission = ref(true);

// 是否含税
const hasTaxParam = ref(false);

// 获取分套结果列表
const getCapacityListData = () => {
	getAnalysisCapacityList(props.loadId).then(async res => {
		console.log(res);
		const recommend = await getRecommend(props.loadId);

		let capcityArr = [];
		if (res) {
			res.map(el => {
				capcityArr.push({
					id: el.id,
					text: `${el.power}kW / ${el.capacity}kWh`,
				});
			});
		}
		capcityList.value = capcityArr;
		console.log("recommend:", recommend);
		if(formState.jobId == undefined){
			if (recommend) {
				// 有推荐值
				formState.jobId = recommend.jobId;
			} else {
				// 设置默认值
				if (capcityArr.length > 0) {
					formState.jobId = capcityArr[0].id;
				}
			}
		}
		

		console.log('222222',formState.jobId);
	});
};

// 开始经济分析
const startEconomicAnalysis = () => {
	formRef.value.validate().then(datas => {
		store.commit("updateProjectStep", 2);
		const send = handleData();

		emit("startAnalysis", send);
	});
};

// 开始经济分析数据处理
const handleData = () => {
	const {
		jobId,
		strategyType,
		unitPrice,
		operationCost,
		lifeYear,
		yearRunDays,
		annualDecayRate,
		yearThreshold,
		earlyPercent,
		laterPercent,
		buildInputTax,
		operationInputTax,
		outputTax,
		yearDepreciation,
		incomeTax,
	} = formState;

	// 经济分析参数
	let economicParam = {
		unitPrice,
		operationCost,
		lifeYear,
		yearRunDays,
		annualDecayRate,
		yearThreshold,
		earlyPercent,
		laterPercent,
	};

	// 税费参数
	let taxParam = {
		buildInputTax,
		operationInputTax,
		outputTax,
		yearDepreciation,
		incomeTax,
	};

	return {
		jobId,
		strategyType,
		economicParam,
		taxParam: commission.value ? taxParam : null, // 判断是否需要税费数据
	};
};

// 创建下拉数据列表
const makeLifeList = () => {
	let count = Number(formState.lifeYear);
	console.log(count);
	let arr = Array.from({length: count}, (v, k) => k + 1);
	console.log(arr);
	yearList.value = arr;

	// 修改默认年限
	let middle = Math.floor(count / 2);
	formState.yearThreshold = middle;
	console.log(middle);
};

const taxChange = val => {
	// 税费还原默认值
	if (val && hasTaxParam.value == false) {
		formState.buildInputTax = 13;
		formState.operationInputTax = 6;
		formState.outputTax = 13;
		formState.yearDepreciation = 5;
		formState.incomeTax = 25;
	}
};

/* 输入条件限制 */
const inputCondition = (key = "", size = 100) => {
	let val = formState[key];

	// 移除非数字和小数点以外的字符
	val = val.replace(/[^0-9.]/g, "");

	// 限制最多两位小数
	const parts = val.split(".");
	if (parts.length > 1) {
		const decimalPart = parts[1].slice(0, 2);
		val = `${parts[0]}.${decimalPart}`;
	}
	// 限制不可为负数
	if (parseFloat(val) < 0) {
		val = "";
	}

	if (size) {
		// 限制大小
		if (parseFloat(val) > size) {
			val = size;
		}
	}

	console.log(val);
	formState[key] = val;
};

// 整数限制
const integerCondition = (key = "", greater = 0, less = 100) => {
	let val = formState[key];

	// 移除非数字字符
	val = val.replace(/\D/g, "");

	// 限制范围在1到50之间
	const value = parseInt(val);
	if (isNaN(value) || value < greater) {
		val = "";
	} else if (value > less) {
		val = less;
	} else {
		val = value.toString();
	}

	console.log(val);
	formState[key] = val;
};

/* 限制两位小数，最大100 */
const taxCondition = key => {
	let val = formState[key];

	// 移除非数字和小数点以外的字符
	val = val.replace(/[^0-9.]/g, "");

	// 限制最多两位小数
	const parts = val.split(".");
	if (parts.length > 1) {
		const decimalPart = parts[1].slice(0, 2);
		val = `${parts[0]}.${decimalPart}`;
	}

	// 限制范围在0到100之间
	const value = parseFloat(val);
	if (isNaN(value) || value < 0) {
		val = "";
	} else if (value > 100) {
		val = "100";
	}

	formState[key] = val;
};

/* 折旧年限 */
const yearDepreciationCondition = () => {
	let val = formState.yearDepreciation;

	// 移除非数字字符
	val = val.replace(/\D/g, "");

	// 限制范围在0到100之间
	const value = parseFloat(val);
	if (isNaN(value) || value < 0) {
		val = "";
	}
	if (formState.lifeYear) {
		if (value > formState.lifeYear) {
			val = formState.lifeYear;
		}
	} else {
		if (value > formState.lifeYear) {
			val = "";
		}
	}
	console.log(val);
	formState.yearDepreciation = val;
};

/* 鼠标离开时：要是以.结尾，去除 */
const mouseBlur = key => {
	let str = String(formState[key]);
	if (str.endsWith(".")) {
		formState[key] = str.slice(0, -1);
	}
};

watch(
	() => props.loadId,
	(newVal, oldVal) => {
		console.log(newVal);
		if (newVal) {
			// 获取分套列表
			getCapacityListData();
		}
	},
	{
		immediate: true,
		deep: true,
	}
);

watch(
	() => props.economicAnalysisVOData,
	newVal => {
		if (newVal) {
			console.log(newVal);
			const {economicParam, taxParam, jobId, strategyType} = newVal;
			const {unitPrice, operationCost, lifeYear, yearRunDays, annualDecayRate, yearThreshold, earlyPercent, laterPercent} = economicParam;
			if (taxParam) {
				const {buildInputTax, operationInputTax, outputTax, yearDepreciation, incomeTax} = taxParam;

				formState.buildInputTax = buildInputTax;
				formState.operationInputTax = operationInputTax;
				formState.outputTax = outputTax;
				formState.yearDepreciation = yearDepreciation;
				formState.incomeTax = incomeTax;

				hasTaxParam.value = true;
			}

			// 参数处理
			formState.jobId = jobId;
			console.log('11111',jobId);
			formState.strategyType = strategyType;
			formState.unitPrice = unitPrice;
			formState.operationCost = operationCost;
			formState.lifeYear = lifeYear;
			formState.yearRunDays = yearRunDays;
			formState.annualDecayRate = annualDecayRate;
			formState.yearThreshold = yearThreshold;
			formState.earlyPercent = earlyPercent;
			formState.laterPercent = laterPercent;

			commission.value = taxParam ? true : false;
		}
	},
	{immediate: true, deep: true}
);

onMounted(() => {
	// 生成生命下拉列表，默认十年
	makeLifeList(10);
});
</script>

<style lang="less" scoped>
.top-tips {
	opacity: 0.45;
	font-family: PingFangSC-Regular;
	font-weight: 400;
	font-size: 14px;
	color: #000000;
	letter-spacing: 0;
	text-align: right;
}
.scheme {
	.row {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
		.font {
			margin: 0px 4px;

			&:first-child {
				margin-left: 0px;
			}
		}
	}
}
.mt24 {
	margin-top: 24px !important;
}
.calculate .content .left .side-box .ant-form-item {
	width: 100% !important;
	.ant-input-affix-wrapper-lg {
		font-size: 14px !important;
	}
}
</style>
